import { initialState as statisticsInitialState, reducer as statisticsReducer } from "Areas/SharedFeatures/taskStatistics";
import reduceReducers from "reduce-reducers";
import { initialState as actionLogInitialState, reducer as actionLogReducer } from "../actionLog";
import { initialState as connectionsInitialState, reducer as connectionsReducer } from "../connections";
import { initialState as ontologicalModelInitialState, reducer as ontologicalModelReducer } from "../ontologicalModel";
import { initialState as passwordPolicyInitialState, reducer as passwordPolicyReducer } from "../passwordPolicy";
import { initialState as tableMethodsInitialState, reducer as tableMethodsReducer } from "../tableMethods";
import { initialState as rolesInitialState, reducer as rolesReducer } from "../roles";
import { initialState as usersInitialState, reducer as usersReducer } from "../users";
import { billingInitialState, billingReducer } from "../billing";
export const initialState = {
    ...tableMethodsInitialState,
    ...usersInitialState,
    ...rolesInitialState,
    ...actionLogInitialState,
    ...connectionsInitialState,
    ...statisticsInitialState,
    ...ontologicalModelInitialState,
    ...passwordPolicyInitialState,
    ...billingInitialState
};
export default reduceReducers(initialState, usersReducer, rolesReducer, actionLogReducer, connectionsReducer, statisticsReducer, ontologicalModelReducer, passwordPolicyReducer, tableMethodsReducer, billingReducer);
